export const siteStatusIds: SiteStatuses = {
  open: '77e8c6d7-9174-4753-81ae-fe32d101b902',
  closed: '1a086283-5c5f-47ba-99cf-2c16fa9eaa90',
};

class SiteStatuses {
  open: string;
  closed: string;
}
